<template>
  <div class="ui-header" :class="[type]">
    <h2 v-if="heading">{{ heading }}</h2>
    <p v-if="text">{{ text }}</p>
  </div>
</template>

<script>
export default {
  name: 'ui-header',
  props: {
    heading: String,
    text: { type: String, required: false },
    type: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss">
.ui-header {
  margin-bottom: 40px;
  h2 {
    margin: 0;
    font-weight: bold;
    font-size: 2rem;
  }
  p {
    margin-top: 20px;
    margin-bottom: 0;
  }
}
</style>
